import { easepick } from '@easepick/bundle';
import { LockPlugin } from '@easepick/bundle';
import { AmpPlugin } from '@easepick/bundle';

const $body = $('body'),
      lang = $('html')[0].lang, 
      classTabActive = 'booking__tab--active',
      classTabPanelActive = 'booking__tab-panel--active',
      $booking = $('.booking'),
      classFieldDropdownVisible = 'field--show-dropdown';
      
// Booking tabs
$('.booking__tab').on('click', function () {
    let tabID = $(this).data('tab-id'),
        $tab = $(this),
        $panel = $(this).closest('.booking').find('.booking__tab-panel[data-tab-id="'+ tabID +'"]');

    if ($panel.length > 0) {
        $tab.addClass(classTabActive).siblings().removeClass(classTabActive);
        $panel.addClass(classTabPanelActive).siblings().removeClass(classTabPanelActive);
    }
});

let currentUrl = window.location.origin,
    baseUrl = 'https://flagshipamsterdam.com'; // production

if (currentUrl.indexOf('dbkdev') >= 0) {
    baseUrl = 'https://flagship.dbkdev.nl'; // dbkdev
} else if (currentUrl.indexOf('flagship.test') >= 0) {
    baseUrl = 'http://flagship.test'; // dbk Guido local
}

if ($('.booking .datepicker').length > 0) {
    const picker = new easepick.create({
        element: '.booking .datepicker',
        css: [
            'https://cdn.jsdelivr.net/npm/@easepick/bundle@1.2.0/dist/index.css',
            baseUrl + '/wp-content/themes/flagship/assets/css/easepick-overwrites.css',
        ],
        grid: 1,
        calendars: 1,
        inline: true,
        lang: lang,
        locale: {
            previousMonth: '&larr;',
            nextMonth: '&rarr;'
        },
        plugins: [
            LockPlugin,
            AmpPlugin
        ],
        LockPlugin: {
            minDate: moment().format('YYYY-MM-DD')
        },
        AmpPlugin: {
            dropdown: {
                months: true,
                years: true,
                minYear: moment().year(),
                maxYear: moment().add(2, 'years').year()
            },
            darkMode: false,
        },
        setup(picker) {
            picker.on('select', (e) => {
                moment.locale(lang);
                let newDate = e.detail.date,
                    dateFormatted = moment(newDate).format('LL'),
                    $field = $('.booking .booking__field.field--show-dropdown'), // only field with this class on page
                    $nextField = $field.nextAll('.booking__field').first(),
                    $input = $field.find('.booking__input');
                $input.val(dateFormatted);

                // trigger next field dropdown if next field input value is still empty
                if ($nextField.length > 0) {
                    setTimeout(function () {
                        $nextField.trigger('click');
                    }, 10);
                }
            });
        }
    });
}

// basic booking dropdown behavior (mobile)
$booking.each(function() {

    $('.booking__field', this).on('click', function() {
        let $field = $(this);

        // close other open dropdowns
        $field.siblings('.'+classFieldDropdownVisible).removeClass(classFieldDropdownVisible);

        // open dropdown
        if ($field.find('.booking__field--dropdown').length > 0) {
            $field.addClass(classFieldDropdownVisible);
        }
    });
});

$(document).on('click', function (e) {

    // hide booking dropdowns when clicking outside booking bar
    if (!$(e.target).closest('.booking').length > 0) {
        $('.booking .booking__field').removeClass(classFieldDropdownVisible);
    }
});

